/* eslint-disable @atlassian/relay/unused-fields */
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql } from 'react-relay';

// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files, jira/relay/no-query
export const SEARCH_SERVICES_BY_ID_QUERY_AGG_RELAY = graphql`
	query gqlJiraJsmServicesSearchServicesByIdQuery($ids: [ID!]!, $propertyKeys: [String!]!) {
		devOpsServicesById(ids: $ids) {
			id
			name
			description
			serviceTier {
				level
			}
			properties(keys: $propertyKeys)
		}
	}
`;
